import { render, staticRenderFns } from "./Zhiboxiangqing.vue?vue&type=template&id=2e0540cc&scoped=true"
import script from "./Zhiboxiangqing.vue?vue&type=script&lang=js"
export * from "./Zhiboxiangqing.vue?vue&type=script&lang=js"
import style0 from "./Zhiboxiangqing.vue?vue&type=style&index=0&id=2e0540cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0540cc",
  null
  
)

export default component.exports